import { useEffect } from "react"
import { setExperimentVariant } from "~/common/analytics"
import { getMetaContentMaybe } from "~/common/get-meta-content"

export const useCollectEmail = () => {
  // Tag the experiment variant (email/control) as an Amplitude user property,
  // only while the experiment runs, so share-page conversion events stay
  // segmentable. Mirrors the top-messages experiment (use-feed-enabled).
  const variant = getMetaContentMaybe("sharepage-input-variant")
  useEffect(() => setExperimentVariant("exp_sharepage_input_variant", variant), [variant])

  return getMetaContentMaybe("collect-email") === "true"
}
